import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const overridesFiles = {
  // TODO: Check if the override files are correct or not.
  // chl: {
  //   bmw: () => import("../../styles/chl/bmw/overrides.css"),
  //   toyota: () => import("../../styles/chl/toyota/overrides.css"),
  // },
  col: {
    "mercedes-benz": () => import("../../styles/col/mercedes-benz/overrides.css"),
  },
};

const ThemeOverride = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const brand = params.get("brands")?.toLowerCase();
    const code = params.get("code")?.toLowerCase();
    
    if (code && brand && overridesFiles[code]?.[brand]) {
      overridesFiles[code][brand]().catch((err) =>
        console.error("Error:", err)
      );
    }
  }, [location.search]);

  return <>{children}</>
}

export default ThemeOverride;